// removed by extract-text-webpack-plugin
module.exports = {"inner":"inner__1r-oo","iframeContainer":"iframeContainer__1_kKZ","iframe":"iframe__1QpEu"};


//////////////////
// WEBPACK FOOTER
// ./routes/faq.sass
// module id = Zw29
// module chunks = 0